// 主题（亮/暗）管理：持久化到 localStorage，落到 <html data-theme="">
const STORAGE_KEY = "vtm-theme";

export const THEMES = { LIGHT: "light", DARK: "dark" };

export const getStoredTheme = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === THEMES.DARK || saved === THEMES.LIGHT) {
      return saved;
    }
  } catch (e) {
    /* ignore */
  }
  // 首次访问跟随系统偏好
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return THEMES.DARK;
  }
  return THEMES.LIGHT;
};

export const applyTheme = theme => {
  const value = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  document.documentElement.setAttribute("data-theme", value);
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    /* ignore */
  }
  return value;
};

export const initTheme = () => applyTheme(getStoredTheme());

export default { THEMES, getStoredTheme, applyTheme, initTheme };
